var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "industries" }, [
    _vm.isTabsInitialized
      ? _c(
          "div",
          [
            !_vm.isIndustryDetail
              ? _c(
                  "v-tabs",
                  {
                    attrs: {
                      "next-icon": "mdi-arrow-right-bold-box-outline",
                      "prev-icon": "mdi-arrow-left-bold-box-outline",
                      "show-arrows": "",
                    },
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  },
                  [
                    _c("v-tabs-slider"),
                    _vm._v(" "),
                    _vm._l(_vm.items, function (item, index) {
                      return _c("v-tab", { key: index }, [
                        _c("span", [
                          _vm._v(
                            "\n                       " +
                              _vm._s(item.label) +
                              "\n                "
                          ),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              },
              _vm._l(_vm.items, function (item, index) {
                return _c("v-tab-item", { key: index }, [
                  item.packageType && item.packageType.length
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "industries__list" },
                          _vm._l(item.packageType, function (packageType, id) {
                            return _c(
                              "div",
                              { key: id, staticClass: "industries__item" },
                              [
                                _c("div", { staticClass: "industries__card" }, [
                                  _c("img", {
                                    staticClass: "industries__img",
                                    attrs: {
                                      src: packageType.img,
                                      alt: packageType.name,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    { staticClass: "industries__title" },
                                    [_vm._v(_vm._s(packageType.name))]
                                  ),
                                  _vm._v(" "),
                                  _c("a", {
                                    staticClass: "industries__link",
                                    attrs: { href: packageType.url },
                                  }),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        (_vm.$vuetify.breakpoint.width > 1650 &&
                          item.packageType.length > 6) ||
                        (_vm.$vuetify.breakpoint.width <= 1650 &&
                          _vm.$vuetify.breakpoint.width > 1500 &&
                          item.packageType.length > 5) ||
                        (_vm.$vuetify.breakpoint.width <= 1500 &&
                          _vm.$vuetify.breakpoint.width > 1024 &&
                          item.packageType.length > 4) ||
                        (_vm.$vuetify.breakpoint.width <= 1024 &&
                          _vm.$vuetify.breakpoint.width > 768 &&
                          item.packageType.length > 3) ||
                        (_vm.$vuetify.breakpoint.width <= 768 &&
                          _vm.$vuetify.breakpoint.width > 550 &&
                          item.packageType.length > 2) ||
                        (_vm.$vuetify.breakpoint.width <= 550 &&
                          item.packageType.length > 1)
                          ? _c("div", { staticClass: "industries__arrows" }, [
                              _c("button", {
                                staticClass:
                                  "industries__arrow industries__arrow--prev",
                                on: {
                                  click: function ($event) {
                                    return _vm.prevSlide(index)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("button", {
                                staticClass:
                                  "industries__arrow industries__arrow--next",
                                on: {
                                  click: function ($event) {
                                    return _vm.nextSlide(index)
                                  },
                                },
                              }),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ])
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "package-properties" }, [
      _c("div", { staticClass: "package-properties__item" }, [
        _c("img", { attrs: { src: "/upload/recommend-1.png", alt: "" } }),
        _vm._v(" "),
        _c("p", [
          _vm._v("Упаковка с маркировкой "),
          _c("br"),
          _vm._v(" Честный знак"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "package-properties__item" }, [
        _c("img", { attrs: { src: "/upload/recommend-2.png", alt: "" } }),
        _vm._v(" "),
        _c("p", [_vm._v("Устойчивая упаковка")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "package-properties__item" }, [
        _c("img", { attrs: { src: "/upload/recommend-3.png", alt: "" } }),
        _vm._v(" "),
        _c("p", [
          _vm._v("Упаковка по стандартам "),
          _c("br"),
          _vm._v(" Халяль"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }